import { MfaMethodDto } from "./types";

export const mapMfaMethods = (mfaMethods: MfaMethodDto[]) => {
  return mfaMethods.map((method) => {
    return {
      label: method.name,
      value: method.code,
    };
  });
};

export const formatPhoneNumber = (phoneNumber: string) => {
  const number = String(phoneNumber);
  const match = number.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return phoneNumber;
};
